"use client";

import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChevronLeft, Menu, Building, User, QrCode, Landmark, Home } from "lucide-react";
import { BreadcrumbItem } from "@/components/ui/breadcrumbs";
import Link from "next/link";
import { useParams } from "next/navigation";
type MobileNavProps = {
  pageItem?: BreadcrumbItem;
};
const MobileNav: React.FC<MobileNavProps> = ({
  pageItem
}) => {
  const goBack = () => {
    window.history.back();
    window.onpopstate = () => {
      window.scrollTo(0, 0);
      window.onpopstate = null; // Remove the event listener
    };
  };
  const [hasHistory, setHasHistory] = React.useState(false);
  React.useEffect(() => {
    setHasHistory(!!window.history.length);
  }, []);
  const params = useParams();
  return <div className="visible flex items-center justify-between mobile:hidden" data-sentry-component="MobileNav" data-sentry-source-file="MobileNav.tsx">
      <div className="flex items-center">
        {hasHistory && <button onClick={goBack} className="rounded-full bg-card p-2 shadow-sm hover:bg-primary/10 focus:bg-card/50 active:bg-card/30">
            <ChevronLeft size={28} />
          </button>}
        {pageItem && <span className="ml-3 flex gap-4 text-lg font-medium">
            {/* {pageItem.icon && <span className="flex items-center">{pageItem.icon}</span>} */}
            {/* {pageItem.label} */}
          </span>}
      </div>

      <DropdownMenu.Root data-sentry-element="unknown" data-sentry-source-file="MobileNav.tsx">
        <DropdownMenu.Trigger className="rounded-full p-2 hover:bg-primary/10 focus:outline-none" data-sentry-element="unknown" data-sentry-source-file="MobileNav.tsx">
          <Menu size={28} data-sentry-element="Menu" data-sentry-source-file="MobileNav.tsx" />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content className="absolute -right-6 z-20 mt-1 min-w-max origin-top-right rounded-md bg-card py-1 shadow-2xl" data-sentry-element="unknown" data-sentry-source-file="MobileNav.tsx">
          <Link href={`/`} passHref data-sentry-element="Link" data-sentry-source-file="MobileNav.tsx">
            <DropdownMenu.Item className="flex items-center px-4 py-2 hover:bg-primary/10" data-sentry-element="unknown" data-sentry-source-file="MobileNav.tsx">
              <Home className="mr-2" size={20} data-sentry-element="Home" data-sentry-source-file="MobileNav.tsx" />
              Acasă
            </DropdownMenu.Item>
          </Link>
          <Link href={`/scan`} passHref data-sentry-element="Link" data-sentry-source-file="MobileNav.tsx">
            <DropdownMenu.Item className="flex items-center px-4 py-2 hover:bg-primary/10" data-sentry-element="unknown" data-sentry-source-file="MobileNav.tsx">
              <QrCode className="mr-2" size={20} data-sentry-element="QrCode" data-sentry-source-file="MobileNav.tsx" />
              Scanează Document
            </DropdownMenu.Item>
          </Link>
          <Link href={`/institutions`} passHref data-sentry-element="Link" data-sentry-source-file="MobileNav.tsx">
            <DropdownMenu.Item className="flex items-center px-4 py-2 hover:bg-primary/10" data-sentry-element="unknown" data-sentry-source-file="MobileNav.tsx">
              <Landmark className="mr-2" size={20} data-sentry-element="Landmark" data-sentry-source-file="MobileNav.tsx" />
              Găsește Instituții
            </DropdownMenu.Item>
          </Link>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>;
};
export default MobileNav;